// @ts-nocheck
import * as Types from '../../../gql/generated/graphql.gen';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSettingsPagesMeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSettingsPagesMeQuery = { __typename?: 'Query', me: { __typename?: 'FamilyAccount', isContractor: boolean, isReceiver: boolean, isMfaActive: boolean } };


export const GetSettingsPagesMeDocument = gql`
    query getSettingsPagesMe {
  me {
    isContractor
    isReceiver
    isMfaActive
  }
}
    `;

/**
 * __useGetSettingsPagesMeQuery__
 *
 * To run a query within a React component, call `useGetSettingsPagesMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsPagesMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsPagesMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSettingsPagesMeQuery(baseOptions?: Apollo.QueryHookOptions<GetSettingsPagesMeQuery, GetSettingsPagesMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSettingsPagesMeQuery, GetSettingsPagesMeQueryVariables>(GetSettingsPagesMeDocument, options);
      }
export function useGetSettingsPagesMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettingsPagesMeQuery, GetSettingsPagesMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSettingsPagesMeQuery, GetSettingsPagesMeQueryVariables>(GetSettingsPagesMeDocument, options);
        }
export function useGetSettingsPagesMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSettingsPagesMeQuery, GetSettingsPagesMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSettingsPagesMeQuery, GetSettingsPagesMeQueryVariables>(GetSettingsPagesMeDocument, options);
        }
export type GetSettingsPagesMeQueryHookResult = ReturnType<typeof useGetSettingsPagesMeQuery>;
export type GetSettingsPagesMeLazyQueryHookResult = ReturnType<typeof useGetSettingsPagesMeLazyQuery>;
export type GetSettingsPagesMeSuspenseQueryHookResult = ReturnType<typeof useGetSettingsPagesMeSuspenseQuery>;
export type GetSettingsPagesMeQueryResult = Apollo.QueryResult<GetSettingsPagesMeQuery, GetSettingsPagesMeQueryVariables>;